export enum AtomDateTagEnum {
  SPAN = "span",
  SMALL = "small",
  P = "p",
  DIV = "div",
}
